﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconRuler2 } from "@tabler/icons-react";

export const TallesPantalonesIcon = IconRuler2;
export const TallesPantalonesHelpText = '* Aquí puede ver la lista de talles de pantalones.'

export class catTallesPantalones extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TallesPantalones";
        this.def.columns.c_category_id.defaultValue = "TallesPantalones";
        this.Title = "Talles de Pantalones";
        this.Icon = TallesPantalonesIcon;
        this.HelpText = TallesPantalonesHelpText;
    }
}